<template>
  <div class="">
    <file-popup
        v-if="isFilePriview"
        v-bind:filedata="filePriviewData"
        @closePopup="closePopup"
    ></file-popup>
    <top-app-bar
        :leftBtnMethod="leftBtnMethod"
        :leftBtnMode="leftBtnMode"
        :rightBtnMethod="rightBtnMethod"
        :rightBtnMode="rightBtnMode"
        :title="title"
        :hideCategory="false"
        staticMode="true"
    >
    </top-app-bar>
    <section v-if="!isFilePriview" class="d-flex h-full flex-column scroll-y">

      <top-app-bar-drawer></top-app-bar-drawer>

      <main v-if="!isFilePriview" class="main-wrapper flex-grow-1 with-footer">
        <div class="d-flex align-items-center bg-white">
          <div
              class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center"
          >
            {{ $t("3139") }}
          </div>
        </div>
        <div class="divider"></div>
        <div class="container container--narrow pdt-50">
          <!-- <div class="mdc-select mdc-select--outlined w-full customize-dropdown " data-mdc-auto-init="MDCSelect">
                        <div class="mdc-select__anchor h-46" aria-labelledby="outlined-select-label">
                          <span class="mdc-notched-outline">
                            <span class="mdc-notched-outline__leading"></span>
                            <span class="mdc-notched-outline__notch">
                              <span id="outlined-select-label font-r t-body3" class="mdc-floating-label">카테고리</span>
                            </span>
                            <span class="mdc-notched-outline__trailing"></span>
                          </span>
                          <span class="mdc-select__selected-text-container">
                            <span id="demo-selected-text" class="mdc-select__selected-text"></span>
                          </span>
                          <span class="mdc-select__dropdown-icon">
                            <svg
                                class="mdc-select__dropdown-icon-graphic"
                                viewBox="7 10 10 5" focusable="false">
                              <polygon
                                  class="mdc-select__dropdown-icon-inactive"
                                  stroke="none"
                                  fill-rule="evenodd"
                                  points="7 10 12 15 17 10">
                              </polygon>
                              <polygon
                                  class="mdc-select__dropdown-icon-active"
                                  stroke="none"
                                  fill-rule="evenodd"
                                  points="7 15 12 10 17 15">
                              </polygon>
                            </svg>
                          </span>
                        </div>

                    <div
                        class="mdc-select__menu mdc-menu mdc-menu-surface mdc-menu-surface--fullwidth mdc--select__custom-dropdown">
                        <ul class="mdc-list">
                            <li class="mdc-list-item mdc-list-item--selected" data-value="data A">
                                <span class="mdc-list-item__ripple"></span>
                                <span class="mdc-list-item__text t-color-bodyGrayA t-body6 font-r">카테고리 1</span>
                            </li>
                            <li class="mdc-list-item" data-value="data B">
                                <span class="mdc-list-item__ripple"></span>
                                <span class="mdc-list-item__text t-color-bodyGrayA t-body6 font-r">Data B</span>
                            </li>
                            <li class="mdc-list-item" data-value="data C">
                                <span class="mdc-list-item__ripple"></span>
                                <span class="mdc-list-item__text t-color-bodyGrayA t-body6 font-r">Data C</span>
                            </li>
                            <li class="mdc-list-item" data-value="data D">
                                <span class="mdc-list-item__ripple"></span>
                                <span class="mdc-list-item__text t-color-bodyGrayA t-body6 font-r">Data D</span>
                            </li>
                            <li class="mdc-list-item" data-value="data E">
                                <span class="mdc-list-item__ripple"></span>
                                <span class="mdc-list-item__text t-color-bodyGrayA t-body6 font-r">Data E</span>
                            </li>
                        </ul>
                    </div>
          </div> -->
          <div
              id="selectDuty"
              :class="{'mdc-select--invalid': categoryValid === true }"
              class="mdc-select mdc-select--outlined w-full mdc--select__custom"
          >
            <i :class="{'t-color-textfieldError': categoryValid === true}"
               class="mdc-select__dropdown-icon select-icon-custom vld-overlay"></i>
            <select
                ref="category"
                v-model="form.category"
                :class="{'t-color-headlineBlack': form.category}"
                class="mdc-select__native-control mdc-select__anchor h-46 mdc-select-control-custom t-body6"
                style="padding-top:10px; border:0; border-right: 16px solid transparent;"
                @change="chooseCategory"
            >
              <option :value="null">
                {{ $t("3141") }}
              </option>
              <option
                  v-for="cat in categoryList.boardCategory
                  ? categoryList.boardCategory.childCategory
                  : ''"
                  :key="cat.id"
                  :value="cat.id"
              >
                {{ cat.name }}
              </option>
            </select>
            <div class="mdc-notched-outline">
              <div class="mdc-notched-outline__leading"></div>
              <div class="mdc-notched-outline__notch"></div>
              <div class="mdc-notched-outline__trailing"></div>
            </div>
          </div>
          <div
              v-show="categoryValid"
              class="t-helper t-color-textfieldError mgl-7 mgr-7 pdt-4 "
          >
            {{ $t("3154") }}
          </div>
          <div class="mgt-24">
            <label
                ref="subjectEl"
                id="subjectEl"
                :class="
                form.subjectValid && !form.contents.subject
                  ? 'mdc-text-field--invalid'
                  : ''
              "
                class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
                data-mdc-auto-init="MDCTextField"
            >
              <span class="mdc-notched-outline">
                <span class="mdc-notched-outline__leading"></span>
                <span class="mdc-notched-outline__notch">
                  <span
                      id="my-label-subject"
                      :class="
                      form.subjectValid
                        ? 't-color-textfieldError'
                        : ''
                    "
                      class="mdc-floating-label"
                  >{{ $t("3142") }}</span
                  >
                </span>
                <span class="mdc-notched-outline__trailing"></span>
              </span>
              <input
                  id="subject"
                  ref="subject"
                  v-model="form.contents.subject"
                  v-validate="'required'"
                  aria-labelledby="my-label-subject"
                  class="mdc-text-field__input custom-filled-input"
                  maxlength="200"
                  name="subject"
                  type="text"
                  @keyup="validateSubject"
              />
              <i
                  class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing"
                  role="button"
                  tabindex="0"
              >report_problem</i
              >
            </label>
            <div
                v-show="form.subjectValid && !form.contents.subject"
                class="t-helper t-color-textfieldError mgl-7 mgr-7 pdt-2 min-h-23"
            >
              <span>
                {{ $t("3153") }}
              </span>
            </div>
          </div>
          <div class="divider mgt-24"></div>
          <div class="messageBox mgt-16">
<!--            <label-->
<!--                id="subjectEl"-->
<!--                :class="-->
<!--                form.subjectValid && !form.contents.body-->
<!--                  ? 'mdc-text-field&#45;&#45;invalid'-->
<!--                  : ''-->
<!--              "-->
<!--                class="mdc-text-field mdc-text-field&#45;&#45;outlined mdc-text-field&#45;&#45;with-trailing-icon mdc-text-field&#45;&#45;textarea w-full "-->
<!--                data-mdc-auto-init="MDCTextField"-->
<!--            >-->
<!--              <span class="mdc-notched-outline">-->
<!--                <span class="mdc-notched-outline__leading"></span>-->
<!--                  <span class="mdc-notched-outline__notch">-->
<!--                    <span-->
<!--                        id="my-label-id"-->
<!--                        :class="-->
<!--                          form.contentValid && !form.contents.body-->
<!--                        ? 't-color-textfieldError'-->
<!--                        : ''-->
<!--                    "-->
<!--                        class="mdc-floating-label"-->
<!--                    >{{ $t("3143") }}</span-->
<!--                    >-->
<!--                </span>-->
<!--                <span class="mdc-notched-outline__trailing"></span>-->
<!--              </span>-->
<!--              <span class="mdc-text-field__resizer">-->
<!--                <textarea-->
<!--                    id="autoheighttext"-->
<!--                    v-model="form.contents.body"-->
<!--                    :class="-->
<!--                    form.contentValid && !form.contents.body ? 't-color-textfieldError' : ''-->
<!--                  "-->
<!--                    aria-labelledby="my-label-id"-->
<!--                    class=" pdl-0 mdc-text-field__input textarea-without-float"-->
<!--                    cols="40"-->
<!--                    maxlength="5000"-->
<!--                    rows="13"-->
<!--                    @keyup="charCount()"-->
<!--                ></textarea>-->
<!--              </span>-->
<!--            </label>-->
            <vue-editor
		            :key="editorKey"
                use-custom-image-handler
                @image-added="uploadEditorFile"
                @image-removed="removeEditorFile"
		            @text-change="textChange"
                :placeholder="$t('1460')"
                :editor-toolbar="customToolbar"
                v-model="form.contents.body"
            />
            <div class="d-flex justify-content-between align-items-center"><div
                v-show="form.contentValid && !form.contents.body"
                class="t-helper t-color-textfieldError mgl-7 mgr-7 pdt-2 min-h-23"
            >
              <span>
                {{ $t("3143") }}
              </span>
            </div>
            <div class="mdc-text-field-helper-line mgl-auto">
              <div class="mdc-text-field-character-counter">
                {{ totalcharacter }} / {{ BODY_MAX_LENGTH }}
              </div>
            </div></div>
          </div>

          <div v-if="form.contents.files.length > 0" class="d-flex scroll-x">
            <div
                v-for="(img, i) in form.contents.files"
                :key="i"
                class="attached-image-preview-126 dk1 mgt-16 mgr-24 position-relative"
            >
              <div v-show="img.saveType.value === mediaTypeConstants.MEDIA_SAVE_TYPE.value">
              <img
                  v-if="getType(img.contentType) === 'image'"
                  :alt="img.originalName"
                  :src="img.resourceUri"
              />
<!--              <div v-if="getType(img.contentType) === 'video'">-->
<!--                <video-player-->
<!--                    v-if="img.subFileResourceUri"-->
<!--                    :options="getPlayerOption(img)"-->
<!--                    :playsinline="true"-->
<!--                    class="video-player-box preview-video preview-video-new"-->
<!--                />-->
<!--                <video-transcode v-else :imageSize="imageSize"></video-transcode>-->
<!--              </div>-->
	              <VideoComponent
			              id="video1"
			              v-else
			              :record="img"
			              :videoSize="'large'"
			              :fullSizeVideo="true">
	              </VideoComponent>
              <span
                  class="remove-img remove-image-new position-absolute t-color-white"
                  tabindex="0"
                  @click="form.contents.files.splice(i, 1)"
                  @keypress="form.contents.files.splice(i, 1)"
              >
                <i class="material-icons t-body1">close</i>
              </span>
              </div>
            </div>
          </div>

          <div class="pdt-16 pdb-8 mgb-16">
            <label
                class="mdc-text-field text-field mdc-text-field--outlined  w-full input-tag-wrapper h-auto pdl-14 min-h-46"
            >
              <i
                  class="material-icons mdc-text-field__icon  t-color-textfieldGuid"
              ><img alt="" class="w-22" src="/images/board/addTag_icon.png"
              /></i>

              <div class="d-flex  pdt-6 pdl-32 pdr-8 pdb-6 flex-wrap">
                <span
                    v-for="(tag, i) in form.tags"
                    :key="i"
                    class="input-tag t-color-contentBlue bg-contentBlueInactive pdl-8 pdr-8 pdt-5 pdb-3 b-radius4 t-body6 mgr-4"
                >{{ tag && tag.name }}
                  <i
                      class="p-5 cursor-pointer material-icons position-relative font-16 close-material-icon"
                      tabindex="0"
                      @click="removeTag(i)"
                      @keypress="removeTag(i)"
                  >close</i
                  >
                </span>
                <input
                    id="tagInput"
                    :placeholder="form.tags.length === 0 ? $t('3144') : ''"
                    aria-label="Label"
                    class="mdc-text-field__input font-r custominput pdl-4 pdt-5 mgt-2 pdb-3 t-color-contentBlue t-body6 max-w-100 pdb-2"
                    type="text"
                    @keyup="searchTags($event)"
                />
              </div>
            </label>
            <div class="container container--narrow">
              <ul v-if="tags && tags.length" class="mdc-list">
                <div v-for="(tag, index) in tags"
                    :key="index">
                <li
                    class="mdc-list-item pdt-15 pdb-15 pdl-0"
                    tabindex="0"
                    @click="addTag(tag)"
                    @keypress="addTag(tag)"
                >
                  <span class="mdc-list-item__ripple"></span>
                  <span
                      class="mdc-list-item__text t-body6 t-color-bodyGrayA font-r "
                  >{{ tag && tag.name }}</span
                  >
                </li>
                <div class="divider"></div>
              </div>
              </ul>
            </div>
            <div
                class="pdl-14 pdt-4 pdr-16 t-body4 t-color-textfieldGuid font-r"
            >
              {{ $t("3145") }}
            </div>
          </div>
          <div
              v-if="form.contents.files.length > 0"
              class="divider mgt-24 mgb-24"
          ></div>
          <div class="community-search-list">
            <div v-for="(file, i) in form.contents.files" :key="i">
              <div v-show="file.saveType.value === mediaTypeConstants.ATTACHED_SAVE_TYPE.value">
              <div class="pdl-16 pdr-16 pdt-6 pdb-6 bg-documentGray mgb-8 b-radius4">
                <div class="d-flex align-items-center justify-content-between search-list ">
                  <div class="d-flex align-items-center">
                    <i class="material-icons t-color-secondaryBtnText pdr-8 t-line-h-29 t-subtitle5 font-20">attach_file</i>
                    <div class="t-body3 font-r t-color-bodyGrayB">
                      {{ file.originalName }}
                    </div>
                  </div>
                  <div
                      class="d-flex align-items-center"
                      tabindex="0"
                      @click="form.contents.files.splice(i, 1)"
                      @keypress="form.contents.files.splice(i, 1)"
                  >
                    <i
                        class="material-icons t-color-secondaryBtnText cursor-pointer font-20"
                    >close</i
                    >
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
          <!-- Static code starts here -->
          <div
              class="mgt-50 t-body5 t-color-bodyGrayA t-line-h-20 l-spacing39 font-r"
          >
            {{ $t("3454") }}
          </div>
          <div
              class="mgt-4 t-helper t-color-bodyGrayB t-line-h-20 l-spacing36 font-r"
          >
            {{ $t("3455") }}: {{ $t("3456") }} │ {{ $t("3457") }}:
            {{ $t("3458") }} │ {{ $t("3459") }}: {{ $t("3460") }}
          </div>
          <!-- Static code ends here -->
          <div class="mgt-100"></div>
        </div>
      </main>
      <div class="footer bg-white bottomStack">
        <div class="divider"></div>
        <div class="container container--narrow pdb-0">
          <photo-album :form="form" class="pdb-34" @removeImage="removeImage" @toggleDocument="toggleDocument"
                       @uploadFile="uploadContentsFile">
            <div slot="attachFile">
              <input
                  id="commentImageUpload"
                  :accept="allowDocumentExt()"
                  class="d-none"
                  type="file"
                  @change="uploadDocFile"
              />
              <button
                  class="material-icons mdc-icon-button"
                  type="image"
                  :class="isActiveFile ? 't-color-iconActive' : 't-color-textfieldGuid'"
                  @click="openFileUpload('commentImageUpload')"
                  @keypress="openFileUpload('commentImageUpload')"
              >
                attach_file
              </button>
            </div>
            <div slot="submitButton">
              <button
                  class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8"
                  tabindex="0"
                  @click="askForRegister"
                  @keypress="askForRegister"
              >
                <div class="mdc-button__ripple"></div>
                <span class="mdc-button__label t-body2 font-r t-nowrap">{{
                    $t("3140")
                  }}</span>
              </button>
              <button
                  class="mdc-button bg-white t-color-secondaryBtnText mgr--12 apply-code"
                  tabindex="0"
                  @click="cancel"
                  @keypress="cancel"
              >
                <div class="mdc-button__ripple"></div>
                <span class="mdc-button__label t-body2 font-r t-nowrap">{{
                    $t("1325")
                  }}</span>
              </button>
            </div>
          </photo-album>
        </div>
      </div>
      <!--------------------------------------------------->
    </section>
  </div>
</template>

<script>
import boardApi from "@/api/boardApi.js";
import ShowSlider from "@/components/board/ShowSlider";
import FilePopup from "./FilePopup";

import {MDCRipple} from "@material/ripple";
import {MDCTextField} from "@material/textfield";

import {fileMixin} from "@/mixins/file";
import {topAppBarMixin} from "@/mixins/topAppBar.js";
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";

import "video.js/dist/video-js.css";
import {videoPlayer} from "vue-video-player";
import {VueEditor} from "vue2-editor";

import _ from "lodash";
import {mediaTypeConstants} from "@/utils/enum/MediaTypeConstants";
import VideoComponent from "@/components/common/VideoComponent.vue";
import { communityConst } from "@/utils/constants/CommunityConstants";
console.log(VueEditor.MarkdownShortcuts);
export default {
  components: {
    videoPlayer,
    VueEditor,
    FilePopup,
    TopAppBar,
    TopAppBarDrawer,
    "show-slider": ShowSlider,
    VideoComponent,
    'photo-album': () => import('@/components/common/PhotoAlbum')
  },

  data() {
    return {
      categoryList: "",
      categoryValid: false,
      totalcharacter: 0,
      form: {
        category: null,
        boardCategory: null,
        status: {
          value: "POST",
          text: "포스트",
          translate: "code.articleStatus.post",
        },
        boardType: null,
        notifyType: null,
        subjectTextField: "",
        subjectValid: false,
        contentValid: false,
        validIcon: "",
        files: [],
        contents: {
          type: {
            value: null
          },
          subject: null,
          body: null,
          linkName: null,
          linkUrl: null,
          files: [],
          editorImages: [],
          images: [],
          video: {
            chunkCount: 0,
            contentType: null,
            duration: 0,
            height: 0,
            id: null,
            name: null,
            originalName: null,
            resourceUri: null,
            size: 0,
            subFileResourceUri: [],
            width: 0,
          },
        },
        fixed: false,
        tags: [],
      },
      boardId: "",
      boardName: "",
      tags: [],
      subjectEl: null,
      contentEl: null,
      // check if upload is set ti image or video
      uploadTypeImg: true,
      isDisabled: false,
      filePriviewData: [],
      isFilePriview: false,
      boardData: null,
      isDrawerOpen: false,
      type: true,
      imageSize: false,
      customToolbar: this.$customToolBar,
      // customToolbar: this.$customToolBar,
      mediaTypeConstants: mediaTypeConstants,
	    editorKey: 1,
	    BODY_MAX_LENGTH: communityConst.BODY_MAX_LENGTH
    };
  },
	watch: {
		'form.contents.body': {
			handler(newValue, oldValue) {
				if (newValue.length > this.BODY_MAX_LENGTH) {
					this.form.contents.body = oldValue;
					++this.editorKey;
				}
				this.charCount();
			},
		}
	},

  mixins: [topAppBarMixin, fileMixin],

  computed: {
    isActiveFile() {
      return _.some(this.form.contents.files, (file) => {
        return file.saveType.value === mediaTypeConstants.ATTACHED_SAVE_TYPE.value
      })
    }
  },

  beforeMount() {
    this.setDetail();
    boardApi
        .boardAuth(this.$route.params)
        .then((response) => {
          this.boardData = response.data.data;
          boardApi
              .fetchMember()
              .then((response) => {
                this.mamberData = response.data.data;
                let myId = this.mamberData.responsibilityId;
                if (this.boardData.authType.value === "STORE") {
                  this.selectedChild = this.boardData.authPermission[0];
                } else {
                  this.selectedChild = this.boardData.authPermission.find(
                      (child) => child.partId == myId
                  );
                }
              })
              .catch((err) => {
              });
        })
        .catch((err) => {
        });
  },

  mounted() {
    window.mdc.autoInit();
    this.boardName = this.$route.query.boardName;
    this.setMaterialUi();
    this.getCategoryList();
	  
	  // const self = this;
	  
	  
		  // document.querySelector('button.ql-link').addEventListener('click', function (e) {
			//   console.log(111);
			//   // document.querySelector('a.ql-action').removeEventListener();
			//   document.querySelector('a.ql-action').addEventListener('click', function (event) {
			// 	  const parser = new DOMParser();
			// 	  console.log(self.form.contents.body);
			// 	  const doc = parser.parseFromString(self.form.contents.body, "text/html");
			// 	  const imageElements = Array.from(doc.querySelectorAll('a'));
			// 	  console.log(imageElements);
			// 	  for(let i=0; i< imageElements.length; ++i) {
			// 		  if (imageElements[i].attributes[0].value.indexOf("http") === -1) {
			// 			  self.form.contents.body = self.form.contents.body.replace(imageElements[i].attributes[0].value, "http://" + imageElements[i].attributes[0].value);
			// 		  }
			// 	  }
			//
			// 	  ++self.editorKey;
			//
			//   });
		  // });
		
	  // document.querySelectorAll('a.ql-action').forEach(function(qlAction) {
	  //
		//   qlAction.addEventListener('click', function (event) {
		// 	  const parser = new DOMParser();
		// 	  console.log(self.form.contents.body);
		// 	  const doc = parser.parseFromString(self.form.contents.body, "text/html");
		// 	  const imageElements = Array.from(doc.querySelectorAll('a'));
		// 	  console.log(imageElements);
		// 	  for(let i=0; i< imageElements.length; ++i) {
		// 		  if (imageElements[i].attributes[0].value.indexOf("http") === -1) {
		// 			  self.form.contents.body = self.form.contents.body.replace(imageElements[i].attributes[0].value, "http://" + imageElements[i].attributes[0].value);
		// 		  }
		// 	  }
	  //
		// 	  ++self.editorKey;
	  //
		//   });
	  // });

  },

  methods: {
    goToPrevious() {
      this.$router.push(
          "/board/" +
          this.$route.params.boardId +
          "?boardName=" +
          encodeURI(this.$route.query.boardName) +
          "&categoryName=" +
          encodeURI(this.$route.query.categoryName)
      );
    },

    cancel() {
      if (this.$route.params.postId)
        this.$router.push(
            "/board/" +
            this.$route.params.boardId +
            "/" +
            this.$route.params.postId +
            "?boardName=" +
            encodeURI(this.$route.query.boardName) +
            "&categoryName=" +
            encodeURI(this.$route.query.categoryName)
        );
      else
        this.$router.push(
            "/board/" +
            this.$route.params.boardId +
            "?boardName=" +
            encodeURI(this.$route.query.boardName) +
            "&categoryName=" +
            encodeURI(this.$route.query.categoryName)
        );
    },

    setMaterialUi() {
     
      const textFields = document.querySelectorAll(".mdc-text-field");
      textFields.forEach((textField) => {
        const mdcTextField = new MDCTextField(textField);
      });
      const buttonRipple = [].map.call(
          document.querySelectorAll(".mdc-button"), function (el) {
            let button = new MDCRipple.attachTo(el);
            return button;
          }
      );
    },

    getCategoryList() {
      boardApi
          .fetchCategoryList(this.$route.params)
          .then((response) => {
            this.categoryList = response.data.data;
          })
          .catch((err) => {
            console.log("err=>", err.message);
          });
    },

    chooseCategory($evt) {
      if ($evt.target.value === "") {
        this.categoryValid = true;
      } else {
        this.categoryValid = false;
      }
    },

    fileDisply(data) {
      this.isFilePriview = true;
      this.filePriviewData = data;
    },

    priviewFiel(file) {
      this.filePriviewData = file;
      this.isFilePriview = true;
    },

    closePopup() {
      this.filePriviewData = Array();
      this.isFilePriview = false;
    },

    charCount: function () {
	    this.totalcharacter = this.form.contents.body.length;
    },

    resetVideo() {
      this.form.contents.video = {
        chunkCount: 0,
        contentType: null,
        duration: 0,
        height: 0,
        id: null,
        name: null,
        originalName: null,
        resourceUri: null,
        size: 0,
        subFileResourceUri: [],
        width: 0,
      };
    },

    videoAudioSelected() {
      if (
          (this.uploadTypeImg &&
              this.form.contents.files &&
              this.form.contents.files.resourceUri) ||
          (!this.uploadTypeImg && this.form.contents.files.length)
      ) {
        this.$alert({
          // title: this.$t('72'),
          content: this.$t("1473"),
          accept: this.$t("1476"),
        });
        return false;
      }
      return true;
    },

    register() {
      if (this.form.id) {
        this.$showLoading();
        let catObject = this.categoryList.boardCategory.childCategory.find(
            (cat) => cat.id === this.form.category
        );
        this.form.category = {
          value: catObject.id,
          text: catObject.name,
          translate: catObject.name,
        };
        this.form.boardCategory = this.form.category;
        // return
        let action = boardApi.updatePost(
            this.form.id,
            this.form,
            this.$route.params.boardId
        );
        action
            .then((response) => {
              this.$hideLoading();
              this.isDisabled = true;
              this.moveToDetail(response.data.data.id);
            })
            .catch((err) => {
              this.$error({content: err.errMsg}).then(() => {
              });
            });
      } else {
        if (this.boardData.userBbsToDayAuth) {
          this.$showLoading();
          let catObject = this.categoryList.boardCategory.childCategory.find(
              (cat) => cat.id === this.form.category
          );
          this.form.category = {
            value: catObject.id,
            text: catObject.name,
            translate: catObject.name,
          };
          this.form.boardCategory = this.form.category;
          // return
          let action = boardApi.register(this.form, this.$route.params.boardId);
          action
              .then((response) => {
                this.$hideLoading();
                this.isDisabled = true;
                this.moveToDetail(response.data.data.id);
              })
              .catch((err) => {
                this.$error({content: err.errMsg}).then(() => {
                });
              });
        } else {
          this.$alert({
            content: this.$t("3064"),
            accept: this.$t("3065"),
          })
              .then(() => {
              })
              .catch(() => {
              });
        }
      }
    },

    moveToDetail(postId) {
      this.$router.push({
        name: "BoardView",
        params: {boardId: this.$route.params.boardId, postId: postId},
        query: this.$route.query,
      });
    },

    setDetail() {
      if (!this.$route.params.postId) return;
      this.$showLoading();
      boardApi
          .boardDetails(this.$route.params)
          .then((response) => {
            this.$hideLoading();
            let responseData = response.data.data;
            Object.assign(this.form, responseData);

            // this.subjectEl.value = responseData.contents.subject
            // this.contentEl.value = responseData.contents.body
            this.form.category = this.form.boardCategory.value;
						console.log(this.form);
            this.charCount();
          })
          .catch((err) => {
            this.$error({content: err.errMsg}).then(() => {
            });
          });
    },

    validateSubject() {
      const subjectTitle = this.form.contents.subject;
      const byteSize = (str) => new Blob([str]).size;
      const result = byteSize(subjectTitle);
      if (subjectTitle.length < 1 || result > 200) {
        this.form.subjectValid = true;
        this.form.validIcon = "warning";
      } else {
        this.form.validIcon = "";
      }
    },

    askForRegister() {
      // check if No content exists
      if (
          this.form.contents.subject == null &&
          this.form.contents.body == null &&
          this.form.category == null
      ) {
        this.form.subjectValid = true;
        this.form.contentValid = true;
        this.categoryValid = true;
        this.form.validIcon = "warning";

      } else if (this.form.category == null) {
        this.categoryValid = true;

      } else if (this.form.contents.subject == null) {
        this.form.subjectValid = true;
        this.form.validIcon = "warning";

      } else if (this.form.contents.body == null || this.form.contents.body.trim() === "") {
	      this.form.contentValid = true;
      } else {
        if(this.form.contents.type) {
          this.form.contents.type.value = 'HTML';
        }
        this.form.validIcon = "";
        this.isDisabled = true;
        this.register();
      }
    },
	
	  async searchTags(event) {
		  const tag = event.target.value.trim();
		  if (tag === '') {
			  this.tags = [];
			  return;
		  }
		  if (event.key === 'Enter') {
			  this.addTag(tag);
		  } else {
			  try {
				  const searchResult = await boardApi.searchTags(tag);
				  this.tags = searchResult.data.data;
			  } catch (err) {
				  this.$error({content: err});
			  }
		  }
	  },
	  
    removeTag(index) {
      this.form.tags.splice(index, 1);
      this.tags = [];
    },

    closeDrawer() {
      this.isDrawerOpen = false;
    },
	
	  goBackListPage() {
      this.$router.push({
        name: "BoardList",
        params: this.$route.params,
        query: this.$route.query,
      });
    },
	  /**
	   * Emitted on Quill's text-change event
	   * @param delta 입력 값
	   * @param oldDelta 이전 입력 값
	   * @param source 입력 주체
	   */
	  textChange(delta, oldDelta, source) {
			// Link의 Url에 Protocol이 없다면 프로토콜을 추가 한다.
			const ops = delta.ops.length === 1 ? delta.ops[0] : delta.ops[1];
			if (ops.attributes &&
					ops.attributes.link &&
					ops.attributes.link.indexOf('http://') === -1 &&
					ops.attributes.link.indexOf('https://') === -1) {
				this.form.contents.body = this.form.contents.body.replace("href=\"" + ops.attributes.link, "href=\"http://" + ops.attributes.link);
				++this.editorKey;
			}
	  }

  },
};
</script>

<style scoped>
.select-border {
  border: 0;
  padding-top: 10px;
}

.write_wrap {
  position: relative;
  padding-bottom: 85px;
}

.write_tag {
  position: relative;

  background: var(--DocumentWhite);
  /* border-bottom: 1px solid var(--Divider); */
}

.write_tag .tag_tail {
  position: relative;
  padding: 2px 15px 0 15px;
  font-size: 12px;
  color: var(--Textfeildguid);
}

.write_tag .tag_form {
  position: relative;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid var(--Divider);
  min-height: 20px;
}

.write_tag .tag_form .tag_btn {
  width: 25px;
  height: 25px;
  font-size: 0;
  text-indent: -9999px;
  background: url("/images/addTag_icon.png") center center no-repeat;
  background-size: 22px auto;
  vertical-align: middle;
  margin-right: 16px;
  min-width: auto !important;
}

html[dir="rtl"] .write_tag .tag_form .tag_btn {
  margin-left: 16px;
}

.write_tag .tag_form span.txt {
  font-size: 14px;
  color: var(--Iconinactive);
  vertical-align: middle;
  line-height: 1;
}

.write_tag .tag_form span.tag {
  display: inline-block;
  padding: 3px 5px;
  background: var(--DocumentGray);
  font-size: 14px;
  color: var(--Primary);
  vertical-align: middle;
  margin-right: 3px;
  line-height: 1.4;
}

html[dir="rtl"] .write_tag .tag_form span.tag {
  margin-left: 3px;
}

.write_tag .tag_form span.tag.txt {
  color: var(--Primary);
  line-height: 1.4;
  background: none;
}

.write_form {
  position: relative;
  padding: 15px;
  background: var(--DocumentWhite);
}

.search_list {
  position: relative;
  background: var(--DocumentGray);
  padding: 15px;
  min-height: calc(100vh - 85px);
}

.search_list .no_data {
  position: relative;
  text-align: center;
  padding: 30px 0 0 0;
  min-height: 300px;
}

.search_list .no_data p:nth-child(1) {
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: var(--HeadlineBlack);
}

.search_list .no_data p:nth-child(2) {
  position: relative;
  padding: 15px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--BodygrayA);
  line-height: 1.57;
}

.texterror::placeholder {
  color: var(--Textfeilderror) !important;
}

.input-tag-wrapper i {
  position: absolute;
  left: 16px;
  top: 14px !important;
}

html[dir="rtl"] .input-tag-wrapper i {
  right: 16px;
}

.video-js{
	right: 0 !important;
}

.border-r-12{
    border-right: 12px solid transparent !important;
}

#autoheighttext {
    height: 320px;
}

.input-tag-wrapper i.close-material-icon {
	top: 3px !important;
	left: 0 !important;
}
>>> .ql-snow em {
	font-style: italic !important;
}

>>> .ql-editor {
	white-space: unset;
}
</style>
